export type ModelKey = { providerID: string; modelID: string; variant?: string }

export function parseConfiguredModel(value: string): ModelKey | undefined {
  const [providerID, ...modelID] = value.split("/")
  if (!providerID || modelID.length === 0) return
  return { providerID, modelID: modelID.join("/") }
}

type ConnectedProvider = {
  id: string
  models: Array<{
    id: string
  }>
}

export function resolveFallbackModel(input: {
  configuredModel?: ModelKey
  recentModels: ModelKey[]
  openanalystModel?: ModelKey
  connectedProviders: ConnectedProvider[]
  defaults: Record<string, string>
  isModelValid: (model: ModelKey) => boolean
}) {
  if (input.configuredModel && input.isModelValid(input.configuredModel)) return input.configuredModel
  const recent = input.recentModels.find(input.isModelValid)
  if (recent) return recent
  if (input.openanalystModel && input.isModelValid(input.openanalystModel)) return input.openanalystModel
}

export function resolveCurrentModel(input: {
  scopeModel?: ModelKey
  agentModel?: ModelKey
  configuredModel?: ModelKey
  recentModels: ModelKey[]
  openanalystModel?: ModelKey
  connectedProviders: ConnectedProvider[]
  defaults: Record<string, string>
  isModelValid: (model: ModelKey) => boolean
}) {
  if (input.scopeModel && input.isModelValid(input.scopeModel)) return input.scopeModel
  if (input.agentModel && input.isModelValid(input.agentModel)) return input.agentModel
  return resolveFallbackModel(input)
}
